module.exports = __webpack_public_path__ + "media/video506.97f26e16.mp4";